export default __webpack_public_path__ + "static/media/icon_food-and-beverage.d8433c29.svg";